import "./UserAE.css";
import { useEffect, useState } from "react";
import {
  ApplyIdentity,
  CompetitorFilterCompetitor,
  CompetitorGetIdentityCompetitorUser,
  CompetitorSetIdentityCompetitorUser,
  UsersFilter,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function UserIdentityCompetitor() {
  const [competitors, setCompetitors] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [userShow, setUserShow] = useState({});
  const [Identity, setIdentity] = useState([]);

  const navigate = useNavigate();

  let { id } = useParams();

  const start = async () => {
    try {
      if (id) {
        const UsersFilterData = await UsersFilter({ id: id });
        if (UsersFilterData.status && UsersFilterData.status === 200) {
          setUserShow(UsersFilterData.data.data.data[0]);
          const CompetitorFilterCompetitorData =
            await CompetitorFilterCompetitor({});
          if (
            CompetitorFilterCompetitorData.status &&
            CompetitorFilterCompetitorData.status === 200
          ) {
            setCompetitors(
              CompetitorFilterCompetitorData.data.data.data.sort(
                (a, b) => a.competitorCategoryOrder - b.competitorCategoryOrder
              )
            );
            const CompetitorGetIdentityCompetitorUserData =
              await CompetitorGetIdentityCompetitorUser(id);
            if (
              CompetitorGetIdentityCompetitorUserData.status &&
              CompetitorGetIdentityCompetitorUserData.status === 200
            ) {
              setIdentity(
                CompetitorGetIdentityCompetitorUserData.data.data.map(
                  (w) => w.competitorId
                )
              );
            }
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  function handleChangeInputCheckBox(e) {
    let id = e.target.id;
    setIdentity((prev) => {
      const idValue = Number(id);
      if (prev.includes(idValue)) {
        return prev.filter((item) => item !== idValue);
      }
      return [...prev, idValue];
    });
  }

  function SelectAll() {
    const items = competitors.map((item) => item.id);

    if (items.length === Identity.length) {
      setIdentity([]);
    } else {
      setIdentity(items);
    }
  }

  const AddUpdate = async () => {
    setLoading(true);
    try {
      let FormIdentityCopy = { UsersId: id, CompetitorsId: Identity };
      const CompetitorSetIdentityCompetitorUserData =
        await CompetitorSetIdentityCompetitorUser(FormIdentityCopy);
      if (
        CompetitorSetIdentityCompetitorUserData.status &&
        CompetitorSetIdentityCompetitorUserData.status === 200
      ) {
        toast.success("افزودن کاربر جدید با موفقیت انجام شد");
        navigate("/Panel/User");
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <span className="m-3">
                {userShow.firstName +
                  " " +
                  userShow.lastName +
                  "(" +
                  userShow.userName +
                  ")"}
              </span>
            </div>
            <div className="d-flex justify-content-center align-items-center w-100 tableC">
              <table className="table">
                <thead className="sticky-header">
                  <tr>
                    <th className="trTable">مرجع</th>
                    <th onClick={SelectAll} className="trTable pointer">
                      دسترسی همه
                    </th>
                  </tr>
                </thead>
                <tbody className="identitystyle">
                  {competitors &&
                    competitors.map((item) => (
                      <tr>
                        <td>
                          {item.competitorCategoryName} - {item.name}
                        </td>
                        <td>
                          <input
                            id={item.id}
                            type="checkbox"
                            onChange={handleChangeInputCheckBox}
                            checked={Identity?.includes(item.id) || false}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button
                onClick={() => {
                  AddUpdate();
                }}
                className="butAU"
              >
                {id ? "ویرایش" : "افزودن"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserIdentityCompetitor;
